







import ECharts from "vue-echarts";
import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import { GetSummaryChartList } from "@/api/pdQualityControlManage/pdSummary";
@Component({
  components: {
    ECharts
  }
})
export default class PdSummaryCake extends AbpBase {
  @Prop() data: any;
  dataList: any;
  loading: boolean = false;
  legendData: [];
  seriesData: [];
  @Watch("data", { immediate: true, deep: true })
  async getData() {
    this.loading = true;
    this.options.legend.data = [];
    this.options.series[0].name = "";
    this.options.series[0].data = [];
    this.options.title.text = "";
    if(this.data.time == undefined ||this.data.chartType== undefined)
    return;
    let res = await GetSummaryChartList(this.data);
    if (res.objects != null) {
      this.dataList = res.objects;
      await this.onDataChanged();
    }
    this.loading = false;
  }
  onDataChanged() {
    if (this.dataList) {
      this.options.legend.data = this.dataList.lengendData;
      this.options.series[0].name = this.dataList.title;
      this.options.series[0].data = this.dataList.summaryChartData;
      this.options.title.text = this.dataList.title;
      this.options.title.subtext = "";
    }
  }

  options = {
    title: {
      text: "",
      subtext: "",
      x: "center"
    },
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b} : {c} ({d}%)"
    },
    legend: {
      orient: "vertical",
      x: "left",
      data: []
    },
    toolbox: {
      show: true,
      feature: {
        mark: { show: true },
        dataView: { show: true, readOnly: false },
        magicType: {
          show: true,
          type: ["pie", "funnel"],
          option: {
            funnel: {
              x: "25%",
              width: "50%",
              funnelAlign: "left",
              max: 1548
            }
          }
        },
        restore: { show: true },
        saveAsImage: { show: true }
      }
    },
    calculable: true,
    series: [
      {
        name: "",
        type: "pie",
        radius: "55%",
        center: ["50%", "60%"],
        data: []
      }
    ]
  };
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdQualityControlManage/pdSummary/cake.vue